import WalkfitIcon from '../img/walkfitlogo.svg';

const getSubscriptionIcon = () => {
    return WalkfitIcon;
};

export default getSubscriptionIcon;
